export enum ModalsName {
	langList = 'langList',
	mobileMenu = 'mobileMenu',
	mobileLangList = 'mobileLangList'
}
